module.exports = __webpack_public_path__ + "static/media/mc-icon-white.b4193ca3.png";